import { useSearchParams } from "react-router-dom";

import { URL_PARAMS } from "@/constants/urlParams";

export const usePageSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number.parseInt(searchParams.get(URL_PARAMS.PAGE) || "1", 10);

  const setPage = (page: number) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set(URL_PARAMS.PAGE, page.toString());
      return next;
    });
  }

  const resetPage = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(URL_PARAMS.PAGE);
    setSearchParams(newParams);
  }
  
  return {
    page,
    resetPage,
    setPage
  };
};
